 <template>
  <div class="statsPage">
    <h1>Admin Stats</h1>
    <h2>{{options.category}} - {{activeDate}}</h2>
    <D3LineChart v-bind:data="mainChart.data" v-bind:emptyData="mainChart.emptyData" />
    <div class="chartController">
      <div class="options radios">
        Category
        <label>
          <input type="radio" name="category" value="users" v-model="options.category" @change="update" /> Users
        </label>
        <label>
          <input type="radio" name="category" value="activities" v-model="options.category" @change="update" /> Activities
        </label>
      </div>
      <div class="options radios">
      Timeframe
        <label>
          <input type="radio" name="timeframe" value="year" v-model="options.timeframe" @change="update" /> Year
        </label>
        <label>
          <input type="radio" name="timeframe" value="month" v-model="options.timeframe" @change="updateTimeframeMonth" /> Month
        </label>
      </div>
      <div class="options">
        Range: <select name="rangeYear" v-model="options.rangeYear" @change="update" >
          <option value=2019> 2019</option>
        </select>
        <span v-if="options.timeframe == 'month'">
          <select name="rangeMonth" v-model="options.rangeMonth" @change="update">
            <option value='01'> Jan</option>
            <option value='02'> Feb</option>
            <option value='03'> Mar</option>
            <option value='04'> Apr</option>
            <option value='05'> May</option>
            <option value='06'> Jun</option>
            <option value='07'> Jul</option>
            <option value='08'> Aug</option>
            <option value='09'> Sep</option>
            <option value='10'> Oct</option>
            <option value='11'> Nov</option>
            <option value='12'> Dec</option>
          </select>
        </span>
      </div>
      <div class="options" v-if="options.timeframe == 'year'">
        Segment: <select name="rangeMonth" v-model="options.segment" @change="update">
          <option value='day'>Day</option>
          <option value='month'>Month</option>
        </select>
      </div>
    </div>
    <div><a class="minor" href="#" @click.prevent="refreshData">Force Data Refresh</a></div>
  </div>
</template>

<script>
import D3LineChart from '@/components/d3/Line'
import DataAdminStats from '@/data/controllers/Admin/Stats/DataAdminStats'
import { format as dateFnsformat } from 'date-fns'
export default {
  name: 'Stats',
  components: {
    'D3LineChart': D3LineChart
  },
  data () {
    return {
      data: null,
      mainChart: {
        data: null,
        emptyData: false
      },
      options: {
        timeframe: 'month',
        rangeYear: '2019',
        rangeMonth: '07',
        segment: 'day',
        category: 'users'
      }
    }
  },
  computed: {
    dateFormatted () {
      return this.options.rangeYear + '-' + this.options.rangeMonth + '-02'
    },
    activeDate () {
      // return this.dateFormatted
      return this.formatDate(this.dateFormatted, this.options.timeframe)
    }
  },
  created () {
    let da = new Date()
    da = dateFnsformat(da, 'YYYY-MM-DD')
    let dasplit = da.split('-')
    this.options.rangeYear = dasplit[0] * 1
    this.options.rangeMonth = dasplit[1]
    this.update()
  },
  methods: {
    async update () {
      let params = {
        'timeframe': this.options.timeframe,
        'category': this.options.category,
        'segment': this.options.segment,
        'range': this.dateFormatted
      }

      let results = await DataAdminStats.getUnique(params)
      if (results) {
        let d = JSON.parse(results.data)
        console.log(d)
        let copy = []
        let $this = this
        d.forEach(function (e) {
          let temp = e
          temp.x = e.date
          temp.y = e[$this.options.category]
          copy.push(temp)
        })
        this.mainChart.data = d
      } else {
        this.mainChart.emptyData = true
      }
    },
    updateTimeframeMonth () {
      this.options.segment = 'day'
      this.update()
    },
    formatDate (date, format) {
      switch (format) {
        case 'month':
          return dateFnsformat(date, 'MMM YYYY')
        case 'year':
          return dateFnsformat(date, 'YYYY')
      }
    },
    async refreshData () {
      await DataAdminStats.refreshData()
      this.update()
    }
  }
}
</script>

<style lang="scss">
  @import '../../../../scss/variables/variables';
  .statsPage {
    .chartController {
      display: flex;
      justify-content: space-around;
      justify-content: space-evenly;
      align-items: center;
      max-width: 800px;
      margin: 5px auto;
      padding: 5px;
      border: 1px solid $brandGreen;
      background: $brandBrightGreen25;
      font-size: 1.4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/stats/Stats.vue